var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseScreen',{attrs:{"loading":_vm.isLoading}},[(_vm.formPreviewData)?_c('FormBuilder',{attrs:{"data":_vm.formPreviewData,"saveSectionMethod":_vm.saveSection,"case_id":_vm.caseId,"entity-id":_vm.entityId,"app":_vm.app},on:{"submit":_vm.submitForm}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }